import { call, put, takeLatest } from "redux-saga/effects";
import PrecertificacionActions, {
  Types as PrecertificacionTypes,
} from "../../stores/precertificacion/Actions";
import PrecertificacionService from "../../services/precertificacion/PrecertificacionService";
import AseguradoService from "../../services/asegurado/AseguradoService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";
import { getMontoTotalReclamado, getMontoTotalArs, getMontoTotalAfiliado } from "../../containers/precertificacion/utils/PrecertificacionUtils";

function* getPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.getPrecertificacionLoading());

  const precertificacionResponse = yield call(
    PrecertificacionService.consultarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !precertificacionResponse?.respuesta ||
    precertificacionResponse?.respuesta?.codigo ===
    ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.getPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    precertificacionResponse?.respuesta?.mensaje !== ResponseCode.OK.message
  ) {
    yield put(
      PrecertificacionActions.getPrecertificacionFailure(
        precertificacionResponse?.respuesta
      )
    );
    return;
  }

  let dataPrecertificacion = precertificacionResponse?.data;

  const procedimientos = dataPrecertificacion?.precertificacion?.procedimientos;

  if(procedimientos?.length > 0){
    dataPrecertificacion?.precertificacion?.procedimientos?.push({
      frecuencia : "Totales",
      montoARS : getMontoTotalArs(procedimientos),
      montoAfiliado : getMontoTotalAfiliado(procedimientos),
      montoReclamado : getMontoTotalReclamado(procedimientos)
    });
  }

  yield put(
    PrecertificacionActions.getPrecertificacionSuccess(
      dataPrecertificacion
    )
  );
}

function* confirmarPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.confirmarPrecertificacionLoading());

  const afiliadoResponse = yield call(
    AseguradoService.consultarAsegurado,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (!afiliadoResponse?.respuesta || afiliadoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (afiliadoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure(afiliadoResponse?.respuesta)
    );
    return;
  }

  const confirmacionResponse = yield call(
    PrecertificacionService.confirmarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !confirmacionResponse?.respuesta ||
    confirmacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    confirmacionResponse?.respuesta?.mensaje?.toLocaleLowerCase() !==
    ResponseCode.OK.message?.toLocaleLowerCase()
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure(
        confirmacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.confirmarPrecertificacionSuccess({
      autorizacion: confirmacionResponse?.data,
    })
  );
}

function* cancelarPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.cancelarPrecertificacionLoading());

  const cancelacionResponse = yield call(
    PrecertificacionService.cancelarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !cancelacionResponse?.respuesta ||
    cancelacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.cancelarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    cancelacionResponse?.respuesta?.codigo !== 0
  ) {
    yield put(
      PrecertificacionActions.cancelarPrecertificacionFailure(
        cancelacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.cancelarPrecertificacionSuccess(cancelacionResponse)
  );
}

const exportedArray = [
  takeLatest(PrecertificacionTypes.GET_PRECERTIFICACION, getPrecertificacion),
  takeLatest(
    PrecertificacionTypes.CONFIRMAR_PRECERTIFICACION,
    confirmarPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.CANCELAR_PRECERTIFICACION,
    cancelarPrecertificacion
  ),
];

export default exportedArray;
